import React, { Component, Fragment } from 'react';
import Paper from '@material-ui/core/Paper';
import CircularProgress from 'material-ui/CircularProgress';
import { DataGrid } from '@material-ui/data-grid';
import Link from '@material-ui/core/Link';
import theme from '../../../muiTheme';
import XLSX from 'xlsx';
import MissingAcreageMap from './MissingAcreageMap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

class MissingAcreages extends Component
{

  constructor(props) {
    super(props);
    this.state =
    {
      x: null,
      y: null
    };
  }

  formatCsvData = () =>
  {
    let firstRow = ['Fire Occurence Record ID', 'FORID', 'Unique Fire Identifier', 'Incident Name', 'Incident Size', 'Calculated Acres', 'Created By System'];
    let dataRows = [firstRow];

    for (let i = 0; i < this.props.data.length; i++)
    {
      let newRow = [this.props.data[i].FireOccurenceRecordID, this.props.data[i].FORID, this.props.data[i].UniqueFireIdentifier, this.props.data[i].IncidentName, this.props.data[i].IncidentSize, this.props.data[i].CalculatedAcres, this.props.data[i].CreatedBySystem];
      dataRows.push(newRow);
    }

    return dataRows;
  }

  handleOnRowClick = (row) => {
    this.setState({
      x: row.x,
      y: row.y
    });
  }

  downloadCsv = () =>
  {
    const workbook = XLSX.utils.book_new();
    let csvData = this.formatCsvData();
    let reportSheet = XLSX.utils.aoa_to_sheet(csvData);
    XLSX.utils.book_append_sheet(workbook, reportSheet, "MissingAcreages");
    XLSX.writeFile(workbook, "MissingAcreages.xlsx");
  }

  render()
  {
    if (!this.props.visible)
    {
      return null;
    }

  const columns = [
    { field: 'FireOccurenceRecordID', headerName: 'ID', width: 90 },
      { 
        field: 'UniqueFireIdentifier', 
        headerName: 'Unique Fire Identifier', 
        width: 170, 
        renderCell: (params) => (
        <Link to={`/incidents/${params.row.FORID}`}>{params.row.UniqueFireIdentifier}</Link>
      )
    },
    { field: 'IncidentName', headerName: 'Incident Name', width: 180 },
    { field: 'IncidentSize', headerName: 'Incident Size', width: 120 },
    { field: 'CalculatedAcres', headerName: 'Calculated Acres', width: 140 },
    { field: 'CreatedBySystem', headerName: 'Created By System', width: 170 }
  ];

  const rows = this.props.data.map(incident =>
    {
      return {
        id: incident.FireOccurenceRecordID,
        FireOccurenceRecordID: incident.FireOccurenceRecordID,
        UniqueFireIdentifier: incident.UniqueFireIdentifier,
        IncidentName: incident.IncidentName,
        IncidentSize: incident.IncidentSize,
        CalculatedAcres: incident.CalculatedAcres != null ? Math.round(incident.CalculatedAcres * 100) / 100 : incident.CalculatedAcres,
        CreatedBySystem: incident.CreatedBySystem,
        FORID: incident.FORID,
        x: incident.x,
        y: incident.y
      }
  });

 
    const loadingIcon = (this.props.isQuerying) ? (
        <div>Querying for Missing Acreages ... <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} /></div>
    ) :
    (
      <Fragment>

      <div style={{ minHeight: 900, minWidth: 900 }}>
      <Table>
        <TableBody>
          <TableRow><TableCell>
            <MissingAcreageMap
              x={this.state.x}
              y={this.state.y}
              open={this.props.open}
            />
            </TableCell>
            </TableRow>
        </TableBody>
      </Table>
                
      <DataGrid isRowSelectable={false} rows={rows} columns={columns} pageSize={15} disableRowSelectionOnClick 
            autoPageSize onRowClick={(rowData) => this.handleOnRowClick(rowData.row)}  />
            
        </div>
      </Fragment>
    );

    return (this.props.visible) ? (
        <Paper>
        <div className="row">
        {loadingIcon}
        </div>
       </Paper>
    ) : "";
  }
}


export default MissingAcreages